// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-customer-portals-jsx": () => import("./../../../src/pages/customer-portals.jsx" /* webpackChunkName: "component---src-pages-customer-portals-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-transformations-jsx": () => import("./../../../src/pages/transformations.jsx" /* webpackChunkName: "component---src-pages-transformations-jsx" */)
}

